import styled, { css } from "styled-components";
import { Modal } from "antd";

export const ModalPopup = styled(Modal)<{ top?: string }>`
  &.noFixedBtn {
    .ant-modal-body > div {
      padding-bottom: 25px !important;
    }

    .ant-modal-body {
      @media (max-width: 375px) {
        padding-left: 0px;
        padding-right: 0px;
        margin: 0 auto;
      }
    }

    .ant-modal-content {
      border-radius: 12px;
      overflow: hidden;
    }

    .wrapper-btn {
      position: static !important;
      padding: 0 !important;
    }
  }
`;

export const Container = styled.div`
  position: relative;
  border-radius: 12px;
  padding-top: 30px;
  padding-bottom: 20px;
  min-width: 250px;
  max-width: 348px;
  text-align: center;
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -5%;
  text-align: center;

  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
  }

  .content {
    margin-top: 14px;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 18px;
  }

  @media screen and (max-width: 768px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  > span {
    margin: auto;
  }

  h2 {
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.46;
    letter-spacing: 0.7px;
    text-align: center;
    color: #ad9a6d;
    margin: 0;
  }
  button {
    border: none;
    height: 45px;
    text-align: center;
    font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
`;

export const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-40%, -50%);
`;

export const ButtonConfirm = styled.button`
  background: #653cd5;
  color: #ffffff;
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -5%;
  text-align: center;
  border-radius: 9px;

  &.mrl-20 {
    margin-left: 20px;
    @media screen and (max-width: 768px) {
      width: 158px !important;
    }
  }

  &.min {
    width: 155px !important;
    margin: 0 auto;
  }
`;

export const ButtonCancel = styled.button`
  border: 1px solid #653cd5 !important;
  background-color: #ffffff;
  color: #333;
  border-radius: 9px;
  color: #653cd5;

  &.otherpage-popup-cancel {
    background-color: #eeeeee;
    border: none !important;
    @media screen and (max-width: 768px) {
      width: 141px !important;
    }
  }
`;

export const WrapperButton = styled.div<{
  isNotMarginTop?: boolean;
  mypage?: boolean;
  onlyOk?: boolean;
}>`
  display: flex;
  background-color: transparent;
  border-top: none;
  justify-content: ${({ onlyOk }) => (onlyOk ? "center" : "space-between")};
  margin-top: ${({ isNotMarginTop }) => (isNotMarginTop ? "0px" : "30px")};
  gap: ${({ mypage }) => (mypage ? "20px" : "0px")};
  > button {
    ${(props) => {
      if (props.onlyOk) {
        return css`
          margin: 0 !important;
          flex: 0 0 calc(100% - 10px);
        `;
      }
      if (props.mypage) {
        return css`
          margin: 0 !important;
          flex: 0 0 calc(50% - 10px);
        `;
      }
    }}
  }
  &.min {
    width: 155px !important;
    margin: 30px auto 16px;
  }
`;
